<template>
	<div class="phindexc-content">
		<div v-for="(item,index) in content" class="img-item" @click="todetails(item.id)">
			<img :src="item.image" />
		</div>
	



	</div>
</template>

<script>
	export default{
		props:['content'],
		methods:{
			todetails(id){
				this.$emit('jump',id);//1.向外部触发一个事件
			}
		},
		mounted(){
			// console.log('contentcontentcontent',this.content)
		}
	}
</script>
<style scoped>
	
	.img-item{
		margin-bottom: 0.3rem;
	}
	.img-item:nth-child(2n){
	}
	.img-item:last-child{
		margin-bottom: 0rem;
	}
	
	
</style>
